import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Observable, Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {Centre} from "../../../../interfaces/Centres";
import {CentreService} from "../../../../services/centre.service";
import {EducationService} from "../../education.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {ChildService} from "../../../../components/child/child.service";
import {DatePipe, TitleCasePipe} from "@angular/common";
import {MatTableDataSource} from "@angular/material/table";
import {AssessmentModel} from "../../../../interfaces/AssessmentModel";
import {
  ViewEducationIndividualComponent
} from "../../components/view-education-individual/view-education-individual.component";
import {MatDialog} from "@angular/material/dialog";
import firebase from "firebase/compat";
import Timestamp = firebase.firestore.Timestamp;
import {MatPaginator} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import {MatSelectChange} from "@angular/material/select";

@Component({
  selector: 'app-education-individual-reporting',
  templateUrl: './education-individual-reporting.component.html',
  styleUrls: ['./education-individual-reporting.component.scss']
})
export class EducationIndividualReportingComponent implements OnInit, OnDestroy {
  private _destroyed$ = new Subject<void>();
  sessionType = ''
  centres$: Observable<Centre[]>
  selectedCentre :any
  conductedBy = ''
  userData = JSON.parse(localStorage.getItem('userData')!)
  startDate?: Date | null
  endDate?: Date | null
  educationData: any[] = []
  dataSource = new MatTableDataSource(this.educationData);
  mAllData:any[]=[]
  mFilteredData:any[]=[]
  displayedColumns: string[] = ['childName', 'centreName', 'sessionDate', 'startTime', 'sessionType', 'subject',   'submittedBy','createdAt', 'action'];


  @ViewChild(MatPaginator) paginator?: MatPaginator;
  @ViewChild(MatSort) sort?: MatSort;


  constructor(readonly centreService: CentreService,
              readonly eduationService: EducationService,
              readonly matSnackBar: MatSnackBar,
              readonly childService: ChildService,
              private titlecasePipe: TitleCasePipe,
              private  readonly matDialog:MatDialog,
              private datePipe:DatePipe,
              private educationService: EducationService,

              ) {

    this.centres$ = centreService.getAllCentres()
  }

  ngOnInit(): void {
    this.educationService.getIndividualEducationList().pipe(takeUntil(this._destroyed$)).subscribe(re => {
      this.educationData = re
      this.dataSource = new MatTableDataSource(this.educationData);
      this.dataSource.sort = this.sort!;
      this.dataSource.paginator = this.paginator!;
      console.log(re)
    })
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

  fetchByCenter($event: MatSelectChange) {
    console.log('FETCH CENTER SELECTED IN EDUCATION')
    this.educationService.getEducation($event.value).pipe(takeUntil(this._destroyed$)).subscribe(re => {
      this.educationData = re
      this.dataSource = new MatTableDataSource(this.educationData);
      this.dataSource.paginator = this.paginator!;
      this.dataSource.sort = this.sort!;
      console.log(re)
    })
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;

    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }

  }

  Search() {
    this.mFilteredData = this.mAllData
    console.log(this.mFilteredData)
    // if centre selected
// 100
    if(this.selectedCentre!=null && this.selectedCentre!=''){
      console.log(this.selectedCentre)
      console.log('into selectedCentre')
      this.mFilteredData = this.mFilteredData.filter((x)=> x.centre == this.selectedCentre)
    }
    if(this.startDate!=null){
      console.log('into startDate')

      this.mFilteredData =  this.mFilteredData.filter((x)=> x.dateOfAssessment.toDate()<=this.startDate!)
// 50
    }
    if(this.endDate!=null){
      console.log('into dateofassessment')

      // 50
      this.mFilteredData =  this.mFilteredData.filter((x)=> x.dateOfAssessment.toDate()>=this.endDate!)

    }

    if(this.sessionType!=null && this.sessionType!=''){
      this.mFilteredData = this.mFilteredData.filter((x)=> x.sessionType ==this.sessionType)
    }

    if(this.conductedBy!=null && this.conductedBy!=''){
      this.mFilteredData = this.mFilteredData.filter((x)=> x.personConductingTest ==this.conductedBy)
      console.log(this.mFilteredData)
    }



    this.dataSource.data=this.mFilteredData
  }

  clearAll() {
    this.startDate = null
    this.endDate =null
    this.conductedBy =''
    this.selectedCentre = ''
    this.sessionType =''
  this.dataSource.data =this.mAllData
  }


  viewDialog(element:any) {
    this.matDialog.open(ViewEducationIndividualComponent,{data:element,
      width:'800%',
      height:'90%'})

  }

  getDateandTime(date: Date):any {
    let d = (date as unknown as Timestamp).toDate()
    let datePipeString = this.datePipe.transform(d,'dd-MMM-yyyy h:mm a ');
    return datePipeString
  }
  getDate(date: Date):any {
    let d = (date as unknown as Timestamp).toDate()
    let datePipeString = this.datePipe.transform(d,'dd-MMM-yyyy');
    return datePipeString
  }

  getTime(date: Date):any {
    let datePipeString: string | null = "NA"

    if (date!=null){
      let d = (date as unknown as Timestamp).toDate()
      datePipeString = this.datePipe.transform(d,"h:mm a")
      // console.log('DATEPIPE STRING',datePipeString )

      return datePipeString
    }
  }

}
